/**
 * Admin Header
 * Header do Admin Console
 */
import { Bell, Search, Command } from 'lucide-react'

export default function AdminHeader() {
  return (
    <header className="h-16 bg-ws-bg-secondary/80 backdrop-blur-lg border-b border-slate-800 flex items-center justify-between px-6">
      {/* Search */}
      <div className="flex items-center gap-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
          <input
            type="text"
            placeholder="Buscar empresas, usuários..."
            className="w-80 pl-10 pr-4 py-2 bg-slate-800/50 border border-slate-700 rounded-xl text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-violet-500"
          />
          <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-1">
            <kbd className="px-1.5 py-0.5 bg-slate-700 rounded text-[10px] text-slate-400 font-mono">
              <Command className="w-3 h-3 inline" />
            </kbd>
            <kbd className="px-1.5 py-0.5 bg-slate-700 rounded text-[10px] text-slate-400 font-mono">K</kbd>
          </div>
        </div>
      </div>
      
      {/* Right Actions */}
      <div className="flex items-center gap-4">
        {/* Environment Badge */}
        <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-amber-500/10 border border-amber-500/20">
          <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse" />
          <span className="text-xs font-mono text-amber-400">DEVELOPMENT</span>
        </div>
        
        {/* Notifications */}
        <button className="relative p-2 rounded-xl hover:bg-slate-800 transition-colors">
          <Bell className="w-5 h-5 text-slate-400" />
          <span className="absolute top-1 right-1 w-2 h-2 bg-rose-500 rounded-full" />
        </button>
        
        {/* System Status */}
        <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-emerald-500/10 border border-emerald-500/20">
          <span className="w-2 h-2 rounded-full bg-emerald-400" />
          <span className="text-xs font-medium text-emerald-400">Sistemas OK</span>
        </div>
      </div>
    </header>
  )
}

